module.exports = __webpack_public_path__ + "img/cd-route.41117289.png";